module.exports = __webpack_public_path__ + "static/img/ding.a271e43.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/ding.jpg
// module id = 464
// module chunks = 11